// @ts-nocheck
import { TECMessagesModel } from "@store/Framework/Types/ApiModels";
import { getTECMessages, GetTECMessagesApiParameter } from "@store/Framework/Services/TaxExemptionCertificatesService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = ApiHandler<GetTECMessagesApiParameter, TECMessagesModel>;

export const DispatchBeginLoadTECMessages: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/TECMessages/BeginLoadTECMessages",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getTECMessages(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404)) {
            props.dispatch({
                type: "Greif/Data/TECMessages/FailedToLoadTECMessages",
            });
            return false;
        }

        throw error;
    }
};

export const DispatchCompleteLoadTECMessages: HandlerType = props => {
    props.dispatch({
        type: "Greif/Data/TECMessages/CompleteLoadTECMessages",
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadTECMessages,
    RequestDataFromApi,
    DispatchCompleteLoadTECMessages,
];

const loadTECMessages = createHandlerChainRunner(chain, "LoadTECMessages");
export default loadTECMessages;
